import React, { useEffect, useState } from "react";
import { Menu, X, Globe, Phone } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { company } from "../mock";

const Navbar = () => {
  const { lang, toggleLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "inicio", label: t.nav.home },
    { id: "nosotros", label: t.nav.about },
    { id: "servicios", label: t.nav.services },
    { id: "por-que", label: t.nav.why },
    { id: "contacto", label: t.nav.contact }
  ];

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/90 backdrop-blur-md shadow-[0_1px_20px_-6px_rgba(20,24,31,.18)]" : "bg-transparent"}`}>
      <nav className="max-w-7xl mx-auto px-5 md:px-8 h-[76px] flex items-center justify-between">
        <button onClick={() => scrollTo("inicio")} className="flex items-center gap-3 group">
          <img src={company.logo} alt="ZD Consulting 正大律师事务所" className="h-11 md:h-12 w-auto object-contain" />
        </button>

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button key={l.id} onClick={() => scrollTo(l.id)} className="nav-link text-[15px] font-medium" style={{ color: "var(--zd-ink)" }}>
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button onClick={toggleLang} className="flex items-center gap-1.5 px-3 py-2 rounded-full border border-zinc-200 text-sm font-semibold hover:border-[var(--zd-red)] transition-colors" style={{ color: "var(--zd-ink)" }}>
            <Globe className="h-4 w-4" />
            <span className={lang === "es" ? "font-bold" : "opacity-50"}>ES</span>
            <span className="opacity-30">/</span>
            <span className={lang === "zh" ? "font-bold font-zh" : "opacity-50 font-zh"}>中文</span>
          </button>
          <button onClick={() => scrollTo("contacto")} className="btn-red hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold">
            <Phone className="h-4 w-4" />{t.nav.cta}
          </button>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2" aria-label="menu">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden bg-white border-t border-zinc-100 px-5 py-4 shadow-lg">
          {links.map((l) => (
            <button key={l.id} onClick={() => scrollTo(l.id)} className="block w-full text-left py-3 text-[15px] font-medium border-b border-zinc-50">
              {l.label}
            </button>
          ))}
          <button onClick={() => scrollTo("contacto")} className="btn-red mt-4 w-full py-3 rounded-full text-sm font-semibold">{t.nav.cta}</button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
